import store from '@/store';
import client from './apiCommonConnector';

export default {
  async getGroups() {
    try {
      const groupsResponse = await client().get('/custom-fields/groups');
      const groupsWithAttributes = groupsResponse.data.data.filter(it => it.attributes && it.attributes.length);
      return groupsWithAttributes.reduce((acc, it) => {
        if (!acc[it.entity_type]) {
          acc[it.entity_type] = [];
        }
        acc[it.entity_type].push(it);
        return acc;
      }, {});
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des champs spécifiques, veuillez réessayer.",
      });
      return {};
    }
  },

  async getEntityValues(entityId) {
    try {
      const valuesResponse = await client().get(`/custom-fields/${entityId}`);
      return valuesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des valeurs de champs spécifiques, veuillez réessayer.",
      });
      return [];
    }
  },
};
